import { render, staticRenderFns } from "./HeaderBase.vue?vue&type=template&id=dae0b54a&scoped=true&"
import script from "./HeaderBase.vue?vue&type=script&lang=js&"
export * from "./HeaderBase.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBase.vue?vue&type=style&index=0&id=dae0b54a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae0b54a",
  null
  
)

export default component.exports